const projectName = "/shiyizhihui_platform_api"




export {projectName};